import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class TokenService {
	private readonly KEY = 'token';
	private token: string | null = null;

	clearAccessToken(): void {
		this.token = null;
	}

	getSession() {
		return sessionStorage.getItem(this.KEY) ?? '';
	}

	getToken() {
		return localStorage.getItem(this.KEY) ?? '';
	}

	hasSession() {
		return !!this.getSession();
	}

	hasToken() {
		return !!this.getToken();
	}

	loadAccessToken(): string | null {
		return this.token;
	}

	removeSession() {
		sessionStorage.removeItem(this.KEY);
	}

	removeToken() {
		localStorage.removeItem(this.KEY);
	}

	saveAccessToken(token: string): void {
		this.token = token;
	}

	saveSession(session: string) {
		sessionStorage.setItem(this.KEY, session);
	}

	saveToken(token: string) {
		localStorage.setItem(this.KEY, token);
	}
}
